import React, { useEffect, useState, useRef } from "react";
import { GetData } from "../Api";
import moment from 'moment';
import {isEmpty, sortBy, map} from 'lodash';
import CustomBarChart from "../Components/BarChart/custom-bar-chart.component";
import PnPUtilService from '../utils/pnp-util.service.js';
import { useTranslation } from "react-i18next";
import WidgetLoader from '../Components/loaders/widget-loader.component.js';
moment.suppressDeprecationWarnings = true;

const PnpMachineSpoilage = (props) => {
  const { t } = useTranslation();
  let dataRefreshTimer = useRef(null);
  let [loading,setLoading] = useState(true);
  let barChartYAxisData = useRef([{ name: "Track Percentage", data: [] }]);
  let barChartXAxisLabels = useRef([5, 4, 3, 2, 1]);
  
  const refreshData = (start, end) => {
    destroyDataRefresh();
    let startTs = moment(start ?? props.from).unix();
    let endTs = moment(end ?? props.to).unix();
    getMachineSpoilageData(startTs, endTs);
    dataRefreshTimer.current = setTimeout(()=>{
      let diff = 0;
      if(props.rangeSelected){
        diff = 3*60*1000; // XXX -> 3 mins x 60 seconds x 1000 milliseconds
      }
      refreshData((props.from+diff), (props.to+diff));
    }, PnPUtilService.PNP_MACHINE_STATUS_REFRESH);
  };
  const destroyDataRefresh = ()=>{
    if(dataRefreshTimer.current){
      clearTimeout(dataRefreshTimer.current);
    }
  };
  const drawSpoilageChart = (data) => {
    if(!isEmpty(data)){
      let updatedDataCollection = [];
      for (const key in data) {
        if(data.hasOwnProperty(key)){
          let spoiledParts = ((data[key].err_parts ?? 0) + (data[key].err_reject ?? 0) + (data[key].reject ?? 0) + (data[key].dislodged_parts ?? 0) + (data[key].no_pickup ?? 0));
          data[key].spoiledParts = spoiledParts;
          const partsUsed = (data[key].pickup - spoiledParts);
          data[key].partsUsed = partsUsed;
          let percentage = (spoiledParts / partsUsed) * 100;
          data[key].percentage = parseFloat(percentage.toFixed(2));
          data[key].track = key;
          updatedDataCollection.push(data[key]);
        }
      }
      updatedDataCollection = sortBy(updatedDataCollection, 'percentage').reverse();
      updatedDataCollection = updatedDataCollection.slice(0, 5);
      let xAxisDataTicks = [];
      updatedDataCollection.forEach((item) => {
        xAxisDataTicks.push(`${item.track}  (PU ${item.partsUsed} - SC ${item.spoiledParts})`);
      });
      let seriesData = map(updatedDataCollection, 'percentage');
      barChartYAxisData.current = [{ name: "Track Percentage", data: seriesData}];
      barChartXAxisLabels.current = xAxisDataTicks;
    }else{
      resetGraph();
    }
    setLoading(false);
  };
  const resetGraph = ()=>{
    barChartYAxisData.current = [{ name: "Track Percentage", data: [] }];
    barChartXAxisLabels.current = [5, 4, 3, 2, 1];
  };
  const getMachineSpoilageData = (startTs, endTs) => {
    setLoading(true);
    resetGraph();
    GetData( `dashboard/pick-place?PNP=SPOILAGE&factoryId=${props.factory.factoryId}&startTs=${startTs}&endTs=${endTs}&machineId=${props.selectedMachineName}&reportType=spoilage`)
    .then((response) => {
      drawSpoilageChart(response?.data ?? []);
    })
    .catch(() => {
      drawSpoilageChart([]);
    });
  };

  useEffect(()=>{
    if(!isEmpty(props.factory) 
    && !isEmpty(props.selectedMachineName) 
    && !isNaN(props.from) 
    && !isNaN(props.to)){
      refreshData();
    }
    return ()=>{
      destroyDataRefresh();
    };
  }, [props]);

  return (
      <div className="cv-pnp-spoilage">
        <div className="px-4 pt-2">
          <div className="d-flex flex-row justify-content-between">
            <div className="inspection-dashboard-title">
              {props.selectedMachineName} - {t("LT_top_5_spoilage_tracks")}
            </div>
          </div>
          <div className="w-100">
            {loading ? 
              <div className="cv-spoilage-loader d-flex justify-content-center align-items-center">
                <WidgetLoader />
              </div> : 
              <div>
                <CustomBarChart 
                  series={barChartYAxisData.current} labels={barChartXAxisLabels.current} 
                  xlabelSuffix="%" ylabelSuffix=""  
                  width={"100%"} height={250} title={t("LT_track")} isHorizontal = {true} />
                <div>
                  <ul className="list-inline">
                    <li className="list-inline-item"><b>SC</b> -{t("LT_spoilage_counts")}</li>
                    <li className="list-inline-item"><b>PU</b> -{t("LT_parts_usage")}</li>
                  </ul>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
  );
};
export default PnpMachineSpoilage;

